export const INIT_STORE = Symbol('INIT_STORE')
export const UPDATE_SCROLL = Symbol('UPDATE_SCROLL')
export const UPDATE_RENDER_DATA = Symbol('UPDATE_RENDER_DATA')
export const TOGGLE_ALL_SELECTION = Symbol('TOGGLE_ALL_SELECTION')
export const ROW_SELECTED_CHANGED = Symbol('ROW_SELECTED_CHANGED')
export const UPDATE_STORE_PARAMS = Symbol('UPDATE_STORE_PARAMS')



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/config/store.js